// const PARTNER_BASE = "http://localhost:8080/v1/r2r/partner";

// export async function getSkillCatalog() {
//   const res = await fetch(`${PARTNER_BASE}/skills/catalog`);
//   if (!res.ok) throw new Error("Skill catalog load failed");
//   return res.json();
// }

// export async function savePartnerSkills(partnerId, categoryIds) {
//   const res = await fetch(`${PARTNER_BASE}/skills`, {
//     method: "PUT",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ partnerId, categoryIds }),
//   });
//   if (!res.ok) throw new Error("Skill save failed");
//   return res.json();
// }
import axios from "../axiosInstance";

export const getSkillCatalog = async () => {
  const res = await axios.get("/partner/skills/category/catalog");
  return res.data;
};

export const getSubCategoriesByCategory = async (categoryId) => {
  const res = await axios.get(`/category/${categoryId}`);
  return res.data.data.subCategory;
};

export const savePartnerSkills = async (categoryIds) => {
  const res = await axios.put("/partner/skills", {
    categoryIds,
  //  subCategoryIds,
  });
  return res.data;
};
